
import { Directive, HostListener, ElementRef, Input } from '@angular/core';
@Directive({
  selector: '[appUsername]'
})
export class UsernameDirective {
  regexStr = '^[a-zA-Z0-9_@]*$';
  langKey:string = localStorage.getItem("lang");
  constructor(private el: ElementRef) { }
  @HostListener('keypress', ['$event']) onKeyPress(event) {
    return new RegExp(this.regexStr).test(event.key);
  }

  @HostListener('paste', ['$event']) blockPaste(event: KeyboardEvent) {
    this.validateFields(event);
  }

  validateFields(event) {
    setTimeout(() => {
      // console.log(this.el.nativeElement.value)
      if (this.langKey === 'uk'){
        //Regex for ukraine lang only
        this.el.nativeElement.value = this.el.nativeElement.value.replace(/\p{IsCyrillic}/g, '').replace(/\s/g, '');
      }
      else {
        this.el.nativeElement.value = this.el.nativeElement.value.replace(/[^a-zA-Z0-9_@ ]/g, '').replace(/\s/g, '');
      }
      event.preventDefault();
    }, 100)
  }

}